<template>
  <div>
    <v-btn color="primary" class="my-3" @click="dialog = true">
      Proceed
    </v-btn>
    <v-dialog v-model="dialog" max-width="630px">
      <v-card class="tw-py-3 md:tw-py-6">
        <v-card-text>
          <h3 class="tw-text-xl md:tw-text-2xl c-blue-text title-font tw-text-center">Please provide some few details</h3>
          <p class="tw-py-2 tw-text-base tw-text-center">Helps us make a better cover for you by providing your age below</p>
          <v-container class="tw-mt-2 md:tw-mt-4">
            <v-form v-model="isValid">
              <v-row class="tw-w-full tw-grid tw-grid-cols-1 tw-px-4 md:tw-px-8">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="principal_dob"
                        label="Your Date of Birth"
                        persistent-hint
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="tw-px-0 md:tw-px-6"
                        :rules="[required('Date Of Birth'), maxAge('Your Age', 63)]"
                    ></v-text-field>
                  </template>
                  <v-date-picker ref="picker_21" v-model="date2" no-title @input="menu2 = false" :max="maxDate()" min="1950-01-01" color="primary"></v-date-picker>
                </v-menu>
                <v-menu
                    v-if="beneficiaryTypes.includes('spouse')"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="spouse_dob"
                        label="Spouse Date of Birth"
                        persistent-hint
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="tw-px-0 md:tw-px-6"
                        :rules="[required('Spouse Date Of Birth'), maxAge('Spouse Age', 63)]"
                    ></v-text-field>
                  </template>
                  <v-date-picker ref="picker_20" v-model="date" no-title @input="menu = false" :max="maxDate()" min="1950-01-01" color="primary"></v-date-picker>
                </v-menu>
                <v-text-field
                    v-if="beneficiaryTypes.includes('child')"
                    v-model="no_of_children"
                    name="child"
                    id="child"
                    label="No. Of Children (Below 25 years)"
                    type="number"
                    min=1
                    oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                    class="tw-px-0 md:tw-px-6"
                    :rules="[required('No. Of Children')]"
                ></v-text-field>
                <v-btn block large
                       color="secondary"
                       class="my-3"
                       :disabled="!isValid"
                       @click="proceed">
                  Proceed
                </v-btn>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import validations from '@/utils/validations';
import { formatDate } from '@/utils/time';
import moment from 'moment/moment';

export default {
  name: 'StartHealthModal',
  props: ['beneficiaryTypes', 'isEdit'],
  data() {
    return {
      principal_dob: null,
      principal_age: null,
      spouse_age: null,
      spouse_dob: null,
      no_of_children: null,
      dialog: false,
      isValid: false,
      ...validations,
      menu2: false,
      date2: '',
      menu: false,
      date: '',
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    date2(_val) {
      this.principal_dob = this.formatDate(this.date2);
      this.principal_age = moment().diff(this.date2, 'years', false);
    },
    menu2(val) {
      // eslint-disable-next-line no-unused-expressions,no-return-assign
      val && setTimeout(() => (this.$refs.picker_21.activePicker = 'YEAR'));
    },
    // eslint-disable-next-line no-unused-vars
    date(_val) {
      this.spouse_dob = this.formatDate(this.date);
      this.spouse_age = moment().diff(this.date, 'years', false);
    },
    menu(val) {
      // eslint-disable-next-line no-unused-expressions,no-return-assign
      val && setTimeout(() => (this.$refs.picker_20.activePicker = 'YEAR'));
    },
  },
  // mounted() {
  //   if (this.isEdit) {
  //     const quote = this.$store.getters['rfq/getHealthQuote'];
  //     this.principal_age = quote.principal_age;
  //     this.spouse_age = quote.spouse_age || null;
  //     this.no_of_children = quote.no_of_children || null;
  //   }
  // },
  methods: {
    proceed() {
      const data = {
        beneficiary_type: this.beneficiaryTypes,
        principal_age: parseInt(this.principal_age, 10),
        ...(this.beneficiaryTypes.includes('spouse') ? { spouse_age: parseInt(this.spouse_age, 10) } : { spouse_age: undefined }),
        ...(this.beneficiaryTypes.includes('child') ? { no_of_children: parseInt(this.no_of_children, 10) } : { no_of_children: undefined }),
      };
      this.$store.commit('rfq/setHealthQuotation', data);
      if (this.isEdit) {
        this.dialog = false;
        this.$root.$emit('health-edit-modal-closed');
        return;
      }
      this.$root.$emit('proceed-to-health-plan');
    },
    maxDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 18);
      return date.toISOString().substr(0, 10);
    },
    formatDate,
  },
};
</script>
